"use client";

import { Button } from "@relume_io/relume-ui";
import { RxChevronRight } from "react-icons/rx";
import { Link } from "react-router-dom";
export function Layout254() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="mb-12 md:mb-18 lg:mb-20">
          <div className="mx-auto max-w-lg text-center">
            <h2 className="mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
              Join Us in Making a Difference for Dogs
            </h2>
            <p className="md:text-md">
              Our NGO is dedicated to rescuing and caring for dogs in need. We
              invite you to be part of our mission.
            </p>
          </div>
        </div>
        <div className="grid place-items-center gap-x-8 gap-y-12 sm:grid-cols-2 md:gap-y-16 lg:grid-cols-[1fr_1.5fr_1fr] lg:gap-x-12">
          <div className="grid w-full grid-cols-1 gap-x-20 gap-y-12 md:gap-y-16">
            <div className="flex flex-col items-center text-center">
              <div className="mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12"
                  alt="Relume logo"
                />
              </div>
              <h3 className="mb-3 text-xl font-bold md:mb-4 md:text-2xl">
                How We Operate
              </h3>
              <p>
                We rescue, rehabilitate, and rehome dogs while engaging the
                community to support our efforts.
              </p>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12"
                  alt="Relume logo"
                />
              </div>
              <Link to="/volunteer">
              <h3 className="mb-3 text-xl font-bold md:mb-4 md:text-2xl">
                Get Involved Today
              </h3>
              </Link>
              <p>
                You can help by donating, volunteering, or adopting a furry
                friend from our shelter.
              </p>
            </div>
          </div>
          <div className="relative order-last w-full sm:col-span-2 lg:order-none lg:col-span-1">
            <img
              src="./media/join-us.jpeg"
              alt="Relume placeholder image"
              className="h-auto w-full object-cover"
            />
          </div>
          <div className="grid w-full grid-cols-1 gap-x-20 gap-y-12 md:gap-y-16">
            <div className="flex flex-col items-center text-center">
              <div className="mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12"
                  alt="Relume logo"
                />
              </div>
              <h3 className="mb-3 text-xl font-bold md:mb-4 md:text-2xl">
                Support Our Mission
              </h3>
              <p>
                Every contribution helps us provide food, medical care, and love
                to dogs in need.
              </p>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  className="size-12"
                  alt="Relume logo"
                />
              </div>
              <h3 className="mb-3 text-xl font-bold md:mb-4 md:text-2xl">
                Join Our Community
              </h3>
              <p>
                Together, we can create a safe and loving environment for all
                dogs in our care.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4 md:mt-18 lg:mt-20">
        <Link to="/donation">
          <Button style={{ color: "white", background: "#147754" }} variant="secondary">Donate</Button>
          </Link>
          <Link to="/volunteer">
          <Button variant="link" size="link">
            Volunteer
          </Button>
          </Link>
          
          {<RxChevronRight />}
        </div>
      </div>
    </section>
  );
}
